import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import PhoneFrame from './phone_frame';

// Langues pour lesquelles on dispose de captures iOS (voir copy-ios-screenshots.js)
const SUPPORTED = ['fr', 'en', 'es', 'it', 'de'];
const FALLBACK_LANG = 'fr';
// Nombre de captures par défaut si le manifest n'est pas (encore) chargé.
const DEFAULT_COUNT = 8;

type Manifest = Record<string, number>;

// Le manifest est généré au build par copy-ios-screenshots.js et donne le
// nombre réel de captures par langue → le carrousel s'adapte automatiquement
// si une publication régénère plus (ou moins) de captures.
const HeroCarousel: React.FC = () => {
  const { t, i18n } = useTranslation();
  const lang = SUPPORTED.includes(i18n.language) ? i18n.language : FALLBACK_LANG;

  const [manifest, setManifest] = useState<Manifest | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch('/screenshots/ios/manifest.json')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data) setManifest(data as Manifest);
      })
      .catch(() => {
        /* on garde le fallback */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const count = (manifest && manifest[lang]) || DEFAULT_COUNT;

  return (
    <PhoneFrame
      className="mx-auto"
      style={{ ['--swiper-theme-color' as string]: '#78350f', ['--swiper-navigation-size' as string]: '26px' }}
    >
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        autoplay={{ delay: 4000, pauseOnMouseEnter: true, disableOnInteraction: false }}
        navigation
        pagination={{ clickable: true }}
        loop
        className="w-full h-full"
      >
        {Array.from({ length: count }, (_, i) => {
          const num = String(i + 1).padStart(2, '0');
          return (
            <SwiperSlide key={num}>
              <img
                src={`/screenshots/ios/${lang}/${num}.png`}
                alt={`${t('home.hero.screenshotAlt', "Capture d'écran de l'app Bible4Me")} ${i + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </PhoneFrame>
  );
};

export default HeroCarousel;
